import { ShieldCheck, ScanSearch, FileCheck2, Lock, Fingerprint, History, KeyRound, Radio } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading, CornerTicks } from "@/components/kit";

const PILLARS = [
    { icon: ShieldCheck, name: "VERIFIABLE", desc: "Actions generate evidence. Evidence can be checked, re-checked and scored." },
    { icon: ScanSearch, name: "AUDITABLE", desc: "Proofs can be inspected by anyone — the record of what happened stays open." },
    { icon: FileCheck2, name: "SETTLABLE", desc: "Verified outcomes can trigger economic settlement in USDC on Arc." },
];

const ITEMS = [
    { icon: Lock, label: "SMART CONTRACT SECURITY" },
    { icon: Radio, label: "ORACLE / EVIDENCE SECURITY" },
    { icon: Fingerprint, label: "AGENT IDENTITY" },
    { icon: History, label: "REPLAY PROTECTION" },
    { icon: KeyRound, label: "SIGNATURE VALIDATION" },
    { icon: ScanSearch, label: "ACCESS CONTROL" },
];

export const SecuritySection = () => (
    <section id="security" data-testid="security-section" className="section relative">
        <div className="shell">
            <Reveal>
                <SectionHeading
                    index="09"
                    eyebrow="SECURITY"
                    title={
                        <>
                            TRUST THROUGH <span className="text-[#1677FF]">VERIFICATION.</span>
                        </>
                    }
                />
            </Reveal>

            <div className="mt-12 grid gap-px border border-white/[0.08] bg-white/[0.06] md:grid-cols-3">
                {PILLARS.map((p, i) => (
                    <Reveal key={p.name} delay={i * 0.08} className="h-full">
                        <div className="flex h-full flex-col bg-[#07111F] p-8 transition-colors duration-300 hover:bg-[#0A1627]">
                            <p.icon size={22} className="text-[#31D8FF]" />
                            <h3 className="mt-6 font-display text-xl font-bold uppercase tracking-tightest">{p.name}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-mute">{p.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.15}>
                <div className="relative mt-6 border border-white/[0.08] bg-[#040811] p-8 md:p-10">
                    <CornerTicks />
                    <p className="label-tech mb-6">SECURITY SURFACE</p>
                    <div className="grid grid-cols-2 gap-x-6 gap-y-5 md:grid-cols-3">
                        {ITEMS.map((it) => (
                            <div key={it.label} className="flex items-center gap-3">
                                <it.icon size={15} className="shrink-0 text-[#1677FF]" />
                                <span className="font-mono text-[10px] font-medium uppercase tracking-[0.18em] text-ink">
                                    {it.label}
                                </span>
                            </div>
                        ))}
                    </div>
                    <p className="mt-8 text-xs leading-relaxed text-mute/70">
                        Security architecture is being engineered ahead of mainnet. No external audit has been completed or
                        claimed — audit plans will be published with the protocol specification.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default SecuritySection;
